// ============================================================
// frontend/src/lib/format.ts
// ============================================================
// Date/time/currency formatting helpers, used app-wide.
// ============================================================

export const formatDate = (d: string | Date | null | undefined): string => d
  ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  : '';

export const formatDateTime = (d: string | Date | null | undefined): string => d
  ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
  : '';

export const formatTime = (d: string | Date | null | undefined): string => d
  ? new Date(d).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  : '';

export const isToday = (d: string | Date | null | undefined): boolean => {
  if (!d) return false;
  const today = new Date();
  const x = new Date(d);
  return today.toDateString() === x.toDateString();
};

export const isPast = (d: string | Date | null | undefined): boolean => {
  if (!d) return false;
  return new Date(d) < new Date();
};

export const formatAmount = (n: number | string | null | undefined): string =>
  Number(n || 0).toLocaleString();

/**
 * Convert ISO datetime to value compatible with <input type="datetime-local">.
 * datetime-local doesn't accept timezones — must be in local "YYYY-MM-DDTHH:mm" form.
 */
export const toDateTimeLocal = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const d = new Date(iso);
  // Adjust for timezone offset because the input shows local time
  const localDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};

/**
 * Convert a datetime-local value back to ISO for the backend.
 * The input gives "2024-12-25T14:30" (no timezone) — we interpret as local.
 */
export const fromDateTimeLocal = (local: string): string => {
  if (!local) return '';
  return new Date(local).toISOString();
};
